import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AboutMe from './components/AboutMe/AboutMe';
import Header from './components/Header/Header';
import Projects from './components/Projects/Projects';
import MotionClicker from './components/Games/MotionClicker/MotionClicker';
import RotatingStar from './components/Games/RotatingStar/RotatingStar';
import ClickSpeed from './components/Games/ClickSpeed/ClickSpeed';
import MomentumSpinner from './components/Games/MomentumSpinner/MomentumSpinner';
import ShrinkingTarget from './components/Games/ShrinkingTarget/ShrinkingTarget';
import TestLatency from './components/Games/TestLatency/TestLatency';
import UnicornRun from './components/Games/UnicornRun/UnicornRun';
import GamesLanding from './components/Games/GamesLanding/GamesLanding';
import styles from './App.module.css';
import AboutMeSide from './components/AboutMe/AboutMeSide';
import NotFound from './components/NotFound/NotFound';

function App() {
  // when in prod, don't be outputting to console.
  if (process.env.NODE_ENV === 'production') {
    console.log = () => { };
    console.error = () => { };
    console.debug = () => { };
  }
  // console.log('test');

  return (
    <>
      <Routes>
        <Route path="/" element={
          <>
            <Header />
            <div className={styles.wrapper}>
              <div className={styles.left}>
                <AboutMeSide />
              </div>
              <div className={styles.right}>
                <AboutMe />
                <Projects />
              </div>
            </div>
          </>
        } />
        <Route path="/games" element={<GamesLanding />} />
        <Route path="/motion-clicker" element={<MotionClicker />} />
        <Route path="/rotating-star" element={<RotatingStar />} />
        <Route path="/click-speed" element={<ClickSpeed />} />
        <Route path="/momentum-spinner" element={<MomentumSpinner />} />
        <Route path="/shrinking-target" element={<ShrinkingTarget />} />
        <Route path="/test-latency" element={<TestLatency />} />
        <Route path="/unicorn-run" element={<UnicornRun />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
